export const CLIENT_APP_DEFAULT_ERROR_MESSAGE = 'A client app error occurred.';
export const VALIDATION_DEFAULT_ERROR_MESSAGE = 'One or more validation errors occurred';

export const INVALID_AUTHORIZATION_CODE_ERROR_MESSAGE = 'Invalid authorization code';

export const HEADER_TEXT_ERROR_MESSAGE = 'We\'re sorry';
export const SUBTITLE_TEXT_ERROR_MESSAGE = 'Please resume your journey, using the following Go Back button, or access one of our websites, using their logos below.';

export const NO_ACCESS_TITLE_TEXT_ERROR_MESSAGE = 'You\'re unauthorized to access this resource directly.';
export const SESSION_EXPIRED_TITLE_TEXT_ERROR_MESSAGE = 'Your session has expired.';

export const ERROR_EMAIL_CONFIRMATION_MESSAGE = 'PreAuthentication failed. Your email address has not been verified, please try again later.';